import { getTrackingCookieSafe } from '@porterin/booking-flow/src/order-review/view/helpers/CookieHelper';
import { OrderReviewCategory } from '@porterin/booking-flow/src/order-review/view/stores/OrderReviewAnalyticsStore';
import { TrackOrderCategory } from '@porterin/booking-flow/src/track-order/view/stores/TrackOrderAnalyticsStore';
import { FareEstimateCategory } from '@porterin/lead-flow/src/domain/store/FareEstimateStore.store';

export const mapPageToCategory = (page_path: string) => {
  switch (page_path) {
    case '/order-review':
      return OrderReviewCategory;
    case '/track-order':
      return TrackOrderCategory;
    case '/fare-estimate':
      return FareEstimateCategory;
    default:
      return '';
  }
};

export const makeBkfEventParameterPayload = () => ({
  Web_tracking_id: getTrackingCookieSafe(),
});
